var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',{staticClass:"pa-0 ma-0"},[_c('CoworkersStatusCalendarVue',{ref:"coworkersStatusCalendar"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }